module.exports = __webpack_public_path__ + "static/media/garbage.7465b719.svg";